import { Link } from "react-router-dom";
import { LOGOS } from "../data/config";
import { useLang, route } from "../i18n";

// Official AVIAH wordmark asset only — never recreated in type.
export const Logo = ({ variant = "white", className = "h-7 w-auto", testid = "logo" }) => {
  const { lang } = useLang();
  return (
    <Link to={route(lang, "home")} aria-label="Aviah Financial — home" data-testid={testid}>
      <img
        src={LOGOS[variant]}
        alt="Aviah Financial"
        width="2000"
        height="897"
        className={className}
        loading="eager"
      />
    </Link>
  );
};
